import CsiFormData from "csi/action/FormData";
import def from "csi/def";
import { View } from "csi/def/View";
import DojoView, { DojoViewProps } from "csi/page/DojoView";
import reflection from "csi/reflection";
import React, { FunctionComponent } from "react";

interface DojoFormProps extends Partial<Omit<DojoViewProps, "viewId" | "viewNodeType">> {
	/** the csi form data to work with */
	formData: CsiFormData;

	/** root node type of the form */
	nodeType: string;
}

export const DojoForm: FunctionComponent<DojoFormProps> = ((props) => {
	const { formData, nodeType, ...otherProps } = props;
	const rc = reflection.getClass(nodeType);
	const defView = def.getClassViewDef(rc, def.DEFAULT_FORM_ID) as View;
	defView.setFormData(formData);

	const viewParams = {
		bPopup: true,
		defView,
	};

	return (
		<DojoView
			fullHeight={false}
			nodeUrl=""
			viewId={def.DEFAULT_FORM_ID}
			viewNodeType={nodeType}
			viewParams={viewParams}
			{...otherProps}
		/>
	);
});

export default DojoForm;